import { defineStore } from "pinia";
import { getSeoData } from "../services/seo";

interface SeoData {
    trip?: string;
    destination?: string;
    activity?: string;
    post_category?: string;
    client_account?: string;
    post?: string;
    page?: string;
    is_breadcrumb_enabled?: boolean;
    breadcrumb_separator?: string;
    homepage_label?: string;
}

export const useSeoStore = defineStore("seo", {
    state: () => ({
        seoData: null as SeoData | null,
    }),
    getters: {

    },
    actions: {
        async dispatchGetSeoData() {
            const response = await getSeoData();
            if (response) this.seoData = response.data.data;
        },
    },
});
